import { render, staticRenderFns } from "./MiniCalendarAgenda.vue?vue&type=template&id=86879898&scoped=true"
import script from "./MiniCalendarAgenda.vue?vue&type=script&lang=js"
export * from "./MiniCalendarAgenda.vue?vue&type=script&lang=js"
import style0 from "./MiniCalendarAgenda.vue?vue&type=style&index=0&id=86879898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86879898",
  null
  
)

export default component.exports